import React, { useState } from "react";
import { Icon } from "@iconify/react";
import Form from "react-bootstrap/Form";

const TextInput = React.forwardRef(
  (
    {
      labelText,
      type = "text",
      placeholder = "",
      errorMessage,
      textarea = false,
      className = "",
      ...rest
    },
    ref
  ) => {
    const [isPasswordVisible, setIsPasswordVisible] = useState(false);

    const togglePasswordVisibility = () => {
      setIsPasswordVisible((prev) => !prev);
    };

    return (
      <Form.Group className={`mb-3 text-start ${className}`}>
        <Form.Label className="d-block w-100">{labelText}</Form.Label>
        <div className="position-relative">
          <Form.Control
            ref={ref}
            as={textarea ? "textarea" : "input"}
            rows={textarea ? 5 : undefined}
            type={
              type === "password" && isPasswordVisible ? "text" : type
            }
            min={type === "number" ? 0 : undefined}
            step={type === "number" ? "any" : undefined}
            placeholder={placeholder}
            isInvalid={!!errorMessage}
            {...rest}
          />
          {type === "password" && (
            <Icon
              icon={isPasswordVisible ? "mdi:eye" : "mdi:eye-off"}
              width="25"
              height="25"
              color="#6E6E73"
              className="cursor-pointer passwordHide"
              onClick={togglePasswordVisibility}
            />
          )}
          <Form.Control.Feedback type="invalid">
            {errorMessage}
          </Form.Control.Feedback>
        </div>
      </Form.Group>
    );
  }
);

export default TextInput;
